//import liraries
import React, { useState, useEffect } from "react";
import { View, Text, TouchableOpacity, Image, FlatList,Dimensions,} from "react-native";
import moment from "moment";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize, } from "rn-responsive-styles";
import { getVehicleDetailsByTxnId } from "../../api/apiManager";
import Loader from "../../common/Loader";
import RootNavigation from "../../utilities/RootNavigation";
import { random } from "lodash";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

const TransactionCard = (props) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [txnData, setTxnData] = useState("");
  const [loading, setLoading] = useState(true);
  const [TXN_DATA, SET_TXN_DATA] = useState([])

  useEffect(() => {
    if (props?.vrn) {
      getTxnData(props?.vrn)
    }
  }, [props?.vrn]);


  useEffect(() => {
    if (TXN_DATA?.length) {
      let tempArr = [];
      if (TXN_DATA?.length > 4) {
        tempArr = TXN_DATA?.slice(0, 4);
      } else {
        tempArr = TXN_DATA;
      }
      if (
        deviceSize === "small" ||
        (deviceSize === "extrasmall" && tempArr?.length > 2)
      ) {
        tempArr = tempArr?.slice(0, 3);
      }
      setTxnData(tempArr);
    }
    setLoading(false);
  }, [TXN_DATA]);

  const getTxnData = (vrn) => {
    setLoading(true)
    getVehicleDetailsByTxnId(vrn).then(res => {
      setLoading(false)
      SET_TXN_DATA(res?.data)
    }).catch(err => { setLoading(false) })
  }


  return (
    <View style={styles.container}>
         <View style={{ width: "100%" }}>
        <Text style={styles.headerTextStyle}>{"TRANSACTION HISTORY"}</Text>
        <FlatList
          style={{ marginTop: 5, marginHorizontal: 10 }}
          data={txnData}
          keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
          initialNumToRender={2}
          renderItem={({ item }) => {
            return (
              <View style={styles.flatListViewStyle}>
                <View style={[ styles.transVerticalLine,{backgroundColor:item?.statementType == "C" ? "#91ce55" : "#c32b2c",flex: 0.2, } ]}/>
                <View style={{ flex: 2 }}>
                  <Text style={styles.dateTextStyle}> {moment(item?.dateTime, "DD-MM-YYYY, HH:mm").format("DD")} </Text>
                  <Text style={styles.monthTextStyle}> {moment(item?.dateTime, "DD-MM-YYYY, HH:mm").format("MMM")} </Text>
                </View>
                <View style={{ flex: 3 }}>
                  <Text style={styles.tranIDTextStyle}>{"UTI TXN ID"}</Text>
                  <Text style={styles.tranIDTextStyle}>{ ((item.transId)?.length > 20) ? (((item.transId)?.substring(0, 20)) + '...') : item?.transId}</Text>
                  <Text style={styles.tranIDTextStyle}>{(item.tollPlaza)?.length > 20 ? (((item.tollPlaza)?.substring(0, 20)) + '...') : item?.tollPlaza }</Text>
                </View>
                <View style={{ flex: 3 }}>
                  <Text style={[ styles.amountTextStyle,{ color: item?.statementType == "C" ? "#91ce55" : "#c32b2c",} ]}>
                    {item?.statementType == "C" ? "+" : "-"}
                    {item?.price.toString().includes(".") ? item?.price.toFixed(2) : item?.price + ".00"}
                  </Text>
                </View>
              </View>
            );
          }}
        />
        <View style={styles.transHorizontalLine} />
        <View style={styles.quickLinksViewStyle}>
          <View style={{ paddingLeft: 20, paddingTop: 15 }}>
            <TouchableOpacity
              onPress={() => {
                RootNavigation.navigate("Transfer")
                global.activeScreen = "Transfer"
              }}
            >
              <Text style={styles.textStyle}>{"Fund Transfer"}</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                RootNavigation.navigate("Profile/MyVehicles", { screen: "My\nVehicles" })
                global.activeScreen = "Profile"
                global.sidebarHide = isSmallDevice ? false : true
              }}
            >
              <Text style={styles.textStyle}>{"My Vehicles"}</Text>
            </TouchableOpacity>
          </View>
          <View style={{ alignItems: "flex-end", justifyContent: "flex-end" }}>
            <Image
              source={require("../../assets/images/Quick_Links_Icon.png")}
              style={styles.quickLinksImageStyle}
            />
          </View>
        </View>
      </View>
      {loading && <Loader />}
    </View>
  );
};

// define your styles
const useStyles = CreateResponsiveStyle(
  {
    container: {
      height: 372.9,
      borderRadius: 12,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.13)",
      shadowOffset: {
        width: 0,
        height: 0.4,
      },
      shadowRadius: 9,
      shadowOpacity: 1,
      marginHorizontal: 10,
      alignItems: "center",
      flexGrow: 1,
      marginHorizontal: 10,
      overflow: "hidden",
    },
    slider: {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      position: "absolute",
      zIndex: 99,
      bottom: 10,
      right: 0,
      left: 0,
      width: "100%",
      alignSelf: "center",
    },
    dropdownStyle: {
      borderWidth: 2,
      borderTopWidth: 1,
      borderColor: "blue",
      minHeight: 50,
      maxHeight: 130,
      position: "absolute",
      zIndex: 9999,
      width: "100%",
      borderBottomRightRadius: 10,
      borderBottomLeftRadius: 10,
      marginTop: 30,
      backgroundColor: "white",
    },
    sliberDisabled: {
      width: 11,
      height: 11,
      backgroundColor: "#7b7b7b",
      shadowColor: "rgba(255, 255, 255, 0.73)",
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
      borderRadius: 5,
      marginRight: 40,
    },
    activeSlider: {
      width: 15,
      height: 15,
      backgroundColor: "#c32b2c",
      shadowColor: "#ed1721",
      shadowOffset: {
        width: 0,
        height: 0,
      },
      shadowRadius: 1,
      shadowOpacity: 1,
      borderRadius: 10,
      marginLeft: 10,
    },
    viewStyle: {
      alignItems: "center",
      flexDirection: "row",
    },

    quickLinksViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      marginHorizontal: "5%",
      alignItems: "center",
      marginTop: 0,
      display: "flex",
      marginBottom:10
    },
    quickLinksImageStyle: {
      height: 30,
      width: 30,
      resizeMode: "center",
      alignSelf: "flex-end",
      position: "relative",
      bottom: -20,
    },
    dateTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 9,
      letterSpacing: 0,
      textAlign: "center",
      color: "#30424e",
    },
    monthTextStyle: {
      fontFamily: "Inter",
      fontSize: 7,
      fontWeight: "500",
      fontStyle: "normal",
      lineHeight: 9,
      letterSpacing: 0,
      textAlign: "center",
      color: "#30424e",
      paddingTop: 5,
    },
    tranIDTextStyle: {
      fontFamily: "Inter",
      fontSize: 10,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 14,
      letterSpacing: 0,
      textAlign: "left",
      color: "#30424e",
    },
    transHorizontalLine: {
      width: 318,
      height: 0,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#f2f2f2",
      marginTop: 40,
      display: "flex",
    },
    amountTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "600",
      fontStyle: "normal",
      lineHeight: 10,
      letterSpacing: 0,
      textAlign: "right",
    },
    transVerticalLine: {
      width: 4.7,
      height: isTabView ? 45 : 50.6,
    },
    tagDetails: {
      height: 24,
      minWidth: 70,
      borderWidth: 0,
      borderColor: "#EFF0F2",
      borderRadius: 6,
      marginHorizontal: 5,
      paddingHorizontal: 10,
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "center",
    },
    activeViewStyle: {
      flexDirection: "row",
      justifyContent: "space-between",
      flex: 1,
    },
    flatListViewStyle: {
      width: "90%",
      height: 50.6,
      backgroundColor: "#f3f4f6",
      marginVertical: 3,
      flexDirection: "row",
      alignItems: "center",
      alignSelf: "center",
      justifyContent: "space-between",
      paddingRight: 10,
    },
    textStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.36,
      textAlign: "left",
      color: "#30424e",
      paddingTop: 5,
    },
    headerTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 23,
      letterSpacing: 0,
      textAlign: "center",
      color: "#9c1d25",
      paddingTop: 10,
    }
  },

  {
    [DEVICE_SIZES.XL]: {
      container: { maxWidth: 350 },
    },

    [DEVICE_SIZES.LG]: {
      container: { maxWidth: 270 },
    },

    [DEVICE_SIZES.MD]: {
      container: {
        height: 262,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginRight: 0,
        marginVertical: "3%",
        alignItems: "center",
      },

      viewStyle3: {
        width: "60%",
        justifyContent: "flex-start",
      },
     
      quickLinksViewStyle: { display: "none" },
      transHorizontalLine: { display: "none" },
      flatListViewStyle: { height: 45 },
     
    },
    [DEVICE_SIZES.SM]: {
      container: {
        width: "100%",
        height: 227,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginVertical: "3%",
        alignItems: "center",
      },
      chartpieViewStyle: {
        width: 80,
        height: 80,
      },
      quickLinksViewStyle: { display: "flex",marginTop:-10 },
      transHorizontalLine: { display: "flex" },

    },
    [DEVICE_SIZES.XS]: {
      container: {
        width: "100%",
        height: 301,
        borderRadius: 12,
        backgroundColor: "#ffffff",
        shadowColor: "rgba(0, 0, 0, 0.13)",
        shadowOffset: {
          width: 0,
          height: 0.4,
        },
        shadowRadius: 9,
        shadowOpacity: 1,
        marginRight: isTabView ? 0 : 10,
        marginVertical: "3%",
        alignItems: "center",
      },
      quickLinksViewStyle: {
        display: "flex",
        marginTop:-10
      },
      transHorizontalLine: {
        display: "flex",
      },
      
     
     
    },
  }
);
//make this component available to the app
export default TransactionCard;
